<div class="card">
  <div class="card-header">
    <div class="d-flex flex-wrap justify-content-between align-items-center w-100">
      <div>
        <h3 class="fw-bold my-2">{{ 'invoices.title' | translate }}</h3>
        <p class="text-muted mb-0">{{ 'invoices.subtitle' | translate }}</p>
      </div>
      <div class="d-flex gap-2 align-items-center">
        <select class="form-select form-select-sm" [(ngModel)]="statusFilter" (change)="onStatusFilterChange()" style="width: auto;">
          <option value="">{{ 'invoices.allStatus' | translate }}</option>
          <option value="pending">{{ 'invoices.pending' | translate }}</option>
          <option value="paid">{{ 'invoices.paid' | translate }}</option>
          <option value="cancelled">{{ 'invoices.cancelled' | translate }}</option>
        </select>
      </div>
    </div>
  </div>
  <div class="card-body">
    @if (loading) {
      <div class="d-flex justify-content-center align-items-center py-10">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">{{ 'invoices.loading' | translate }}</span>
        </div>
      </div>
    } @else if (orders.length === 0) {
      <div class="empty-state">
        <i class="fa fa-file-invoice"></i>
        <p>{{ 'invoices.noInvoices' | translate }}</p>
      </div>
    } @else {
      <div class="invoices-list">
        @for (order of orders; track order.order_id) {
          <div class="invoice-card">
            <div class="invoice-header">
              <div class="invoice-company">
                @if (order.company) {
                  <strong>{{ order.company.company_name }}</strong>
                } @else {
                  <span class="text-muted">{{ 'invoices.unknown' | translate }}</span>
                }
              </div>
              <div class="invoice-badges">
                <span class="badge {{ getOrderStatusClass(order.status) }}">{{ getStatusTranslation(order.status) }}</span>
                <span class="badge badge-light-secondary ms-2">{{ getPaymentTypeLabel(order.payment_type) }}</span>
              </div>
            </div>

            <div class="invoice-body">
              <div class="invoice-items">
                @for (line of order.order_lines; track line.line_id) {
                  <div class="invoice-item">
                    <span class="item-description">{{ line.description }}</span>
                    <span class="item-qty">x{{ line.quantity }}</span>
                    <span class="item-price">{{ formatPrice(line.total_cents + line.vat_cents) }} {{ order.currency }}</span>
                  </div>
                }
              </div>

              <div class="invoice-total">
                <span class="total-label">{{ 'invoices.total' | translate }}</span>
                <span class="total-amount">{{ formatPrice(order.total_cents) }} {{ order.currency }}</span>
              </div>

              @if (order.payment_type === 'subscription' && order.subscription_status) {
                <div class="subscription-info">
                  <i class="fa fa-sync-alt me-1"></i>
                  {{ 'invoices.subscriptionStatus' | translate }}: {{ getSubscriptionStatusTranslation(order.subscription_status) }}
                  @if (order.next_billing_date) {
                    <span class="text-muted ms-2">{{ 'invoices.nextBilling' | translate }}: {{ order.next_billing_date | date:'mediumDate' }}</span>
                  }
                </div>
              }
            </div>

            <div class="invoice-footer">
              <div class="invoice-date">
                <i class="fa fa-calendar me-1 text-muted"></i>
                {{ order.created_at | date:'mediumDate' }}
                @if (order.due_date && order.status === 'pending') {
                  <span class="text-warning ms-2">
                    <i class="fa fa-clock me-1"></i>
                    {{ 'invoices.due' | translate }}: {{ order.due_date | date:'mediumDate' }}
                  </span>
                }
                @if (order.paid_at && order.status === 'paid') {
                  <span class="text-success ms-2">
                    <i class="fa fa-check me-1"></i>
                    {{ 'invoices.paidOn' | translate }}: {{ order.paid_at | date:'mediumDate' }}
                  </span>
                }
              </div>

              <div class="invoice-actions">
                @if (order.status === 'pending') {
                  <app-button
                    [variant]="'primary'"
                    [label]="'invoices.payNow' | translate"
                    [iconClass]="'fa fa-credit-card'"
                    [size]="'sm'"
                    [loading]="payingOrderId === order.order_id"
                    (clicked)="payInvoice(order)"
                  />
                }
                @if (isSubscriptionActive(order)) {
                  <app-button
                    [variant]="'ghost'"
                    [label]="'invoices.cancelSubscription' | translate"
                    [iconClass]="'fa fa-times'"
                    [size]="'sm'"
                    (clicked)="cancelSubscription(order)"
                  />
                }
              </div>
            </div>
          </div>
        }
      </div>
    }
  </div>
</div>
